<template>
  <v-breadcrumbs :items="items">
    <template v-slot:item="{ item }">
      <v-breadcrumbs-item
          :to="item.href"
          :disabled="item.disabled"
      >
        {{ item.text.toUpperCase() }}
      </v-breadcrumbs-item>
    </template>
    <div class="card_container" >
      <div class="card_header" >
        <div>เพิ่มข้อมูลผู้ใช้งาน</div>
      </div>

      <v-breadcrumbs :items="items">
        <template v-slot:item="{ item }">
          <v-breadcrumbs-item
              :to="item.href"
              :disabled="item.disabled"
          >
            {{ item.text.toUpperCase() }}
          </v-breadcrumbs-item>
        </template>
      </v-breadcrumbs>
      <div class="form_card" >
        <v-form
            ref="form"
            v-model="valid"
            lazy-validation
        >
          <v-text-field
              v-model="first_name"
              :rules="[v => !!v || 'กรุณากรอกขื่อจริง']"
              label="ชื่อจริง"
              required
          ></v-text-field>
          <v-text-field
              v-model="last_name"
              :rules="[v => !!v || 'กรุณากรอกนามสกุล']"
              label="นามสกุล"
              required
          ></v-text-field>

          <v-text-field
              v-model="user_name"
              :counter="10"
              :rules="[v => !!v || 'กรุณากรอก Username']"
              label="UserName"
              required
          ></v-text-field>

          <v-text-field
              v-model="email"
              :rules="email_rules"
              label="E-mail"
              required
          ></v-text-field>



          <v-text-field
              v-model="password"
              :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
              :rules="[v => !!v || 'กรุณากรอกรหัสผ่าน']"
              :type="show1 ? 'text' : 'password'"
              name="input-10-1"
              label="รหัสผ่าน"
              counter
              @click:append="show1 = !show1"
          ></v-text-field>


          <v-text-field
              v-model="password_confirm"
              :append-icon="show4 ? 'mdi-eye' : 'mdi-eye-off'"
              :rules="[v => !!v || 'กรุณากรอกยืนยันรหัสผ่าน', v => v === this.password || 'รหัสผ่านไม่ตรงกัน']"
              :type="show4 ? 'text' : 'password'"
              name="input-10-2"
              label="ยืนยันรหัสผ่าน"
              :error="this.password !== this.password_confirm"
              @click:append="show4 = !show4"
          ></v-text-field>

          <v-text-field
              v-model="pincode"
              :counter="10"
              :rules="[v => !!v || 'กรุณากรอก pincode 6 หลัก']"
              label="pincode"
              required
          ></v-text-field>

          <v-text-field
              v-model="rfidcode"
              :rules="[v => !!v || 'กรอกกรอกข้อมูล rfid']"
              label="เลข RFID"
              required
          ></v-text-field>

          <v-checkbox
              v-model="is_admin"
              label="admin"
          ></v-checkbox>

          <v-checkbox
              v-model="withdaw"
              label="เลือกรางการเบิก"
          ></v-checkbox>

          <div v-if="withdaw" >
            <div class="controls">
              <button type="button" @click="checkAll" class="control-button">เลือกทั้งหมด</button>
              <button type="button" @click="uncheckAll" class="control-button">ยกเลิกทั้งหมด</button>
            </div>

            <div class="list_rail" >
              <button
                  type="button"
                  v-for="number in 100"
                  :key="number"
                  class="item_button"
                  :class="{ 'checked': selectedButtons.includes(number) }"
                  @click="toggleButton(number)"
              >
                {{ number }}
              </button>
            </div>
          </div>

          <v-file-input
              @change="Preview_image"
              :rules="[v => !!v || 'กรุณาอัพโหลดรูป']"
              accept="image/png, image/jpeg, image/bmp"
              placeholder="เลือก รูปโปรไฟล์"
              prepend-icon="mdi-camera"
              label="รูปโปรไฟล์"
          ></v-file-input>
          <div class="image_preview_container" >
            <img  id="image_preview" src=""  />
          </div>


          <div align="center" style="margin-top: 2rem" >
            <v-btn
                class="mr-4 btn-primary-custom"
                @click="validate"
            >
              เพิ่มข้อมูล
            </v-btn>

            <v-btn
                color="error"
                class="mr-4 btn-cancel-custom"
                @click="reset"
            >
             ล้างค่า
            </v-btn>


          </div>

        </v-form>
      </div>

    </div>
  </v-breadcrumbs>



</template>

<script>
import {GetDepartment, GetMachine, UserRegister} from "../../lib/controller";
import {baseUrl} from "../../const/api";
import $ from 'jquery'

export default {
  name: "Users",
  data: () => ({
    rules: [
      value => !value || value.size < 2000000 || 'Avatar size should be less than 2 MB!',
    ],
    machine_item:{},
    machine_id:0,
    valid: true,
    pincode:"",
    file:"",
    show1: false,
    show4: false,
    is_admin:false,
    first_name: '',
    last_name: '',
    user_name: '',
    password: '',
    password_confirm: '',
    email: '',
    rfidcode: '',

    email_rules: [
      v => !!v || 'E-mail is required',
      v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
    ],


    department: '',


    name: '',
    nameRules: [
      v => !!v || 'Name is required',
      v => (v && v.length <= 10) || 'Name must be less than 10 characters',
    ],



    select: null,
    itemss:[],
    checkbox: false,

    baseUrl:baseUrl,
    items: [
      {
        text: 'Home',
        disabled: false,
        href: '/',
      },
      {
        text: 'ข้อมูลผู้ใช้',
        disabled: false,
        href: '/Users',
      },
      {
        text: 'เพิ่มข้อมูลผู้ใช้',
        disabled: true,
        href: '/Users',
      },
    ],
    dialog: false,
    dialogDelete: false,
    headers: [
      {
        text: 'รูปโปรไฟล์',
        align: 'start',
        sortable: false,
        value: 'image',
      },
      { text: 'ชื่อ', value: 'first_name' },
      { text: 'นามสกุล', value: 'last_name' },
      { text: 'แผนก', value: 'departments[0].title' },
      { text: 'RFID', value: 'rfidcode' },
      { text: 'Actions', value: 'actions', sortable: false },
    ],
    desserts: [],
    editedIndex: -1,
    resultData:[],
    withdaw: false,
    selectedButtons: [],
  }),

  computed: {

  },
  watch: {

  },

  created () {
    this.initialize()
    this.GetDepartment()
    this.GetMachines()
  },

  methods: {
    initialize () {

    },
    toggleButton(number) {
      if (this.selectedButtons.includes(number)) {
        this.selectedButtons = this.selectedButtons.filter(item => item !== number);
      } else {
        this.selectedButtons.push(number);
      }
    },
    checkAll() {
      this.selectedButtons = Array.from({ length: 100 }, (_, i) => i + 1);
    },
    uncheckAll() {
      this.selectedButtons = [];
    },
    async GetMachines(){
      let machine = [];
      const { status , results } = await GetMachine();
      if(status === 200){

        results.data.forEach(function (result){
          console.log(result)
          machine.push({
            "label":result.title,
            "id":result.machine_number,
          })
        });
      }

      this.machine_item = machine;
      console.log(this.itemss)

    },
    validate () {
      console.log(this.file)
      if(this.$refs.form.validate()){
        this.UserRegister();
      }
    },
    reset () {
      this.$refs.form.reset()
      $('#image_preview').attr('src', '');
    },
    async UserRegister(){
      let Swal = this.$swal;

      let formData = new FormData();
      formData.append("first_name",this.first_name)
      formData.append("last_name",this.last_name)
      formData.append("user_name",this.user_name)
      formData.append("password",this.password)
      formData.append("email",this.email)
      formData.append("rfidcode",this.rfidcode)
      formData.append("pincode",this.pincode)
      formData.append("is_admin",this.is_admin ? 1 : 0)
      formData.append("department_id",1)
      formData.append("file",this.file)
      formData.append("machine_id",JSON.parse(localStorage.getItem('user')).machine_id)

      if(this.selectedButtons.length != 0){
        formData.append("rail",this.selectedButtons.toString())
      }
      if(this.limit){
        formData.append("limit",this.limit)
      }


      const { status , results } = await UserRegister(formData,this.machine_id);
      if(status === 200){
        Swal({
          icon: 'success',
          title: 'Success',
        })
        this.$refs.form.reset()
        $('#image_preview').attr('src', '');
        console.log(results)
      }else{

        Swal({
          icon: results.icon,
          title: results.message,
        })

      }

    },

    async GetDepartment(){
      let department = [];
      const { status , results } = await GetDepartment();
      if(status === 200){

        results.data.forEach(function (result,index){
          console.log(index)
          department.push({
            "label":result.title,
            "id":result.department_id,
          })
        });
      }

      this.itemss = department;
      console.log(this.itemss)

    },
    Preview_image(e) {
      if (e) {
        this.file = e;
        $('#image_preview').attr('src', URL.createObjectURL(e)); // jQuery selector
      }
    },
  },
}


</script>

<style scoped>
.card_container{
  width: 100%;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #ffffff;
  background-clip: border-box;
  border: 1px solid #EBEDF3;
  border-radius: 0.42rem;
}
.card_header{
  padding: 1.5rem 2rem;
  margin-bottom: 0;
  background-color: #ffffff;
  border-bottom: 1px solid #EBEDF3;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.form_card{
  padding:2rem;
}
.image_preview_container{
  display: flex;
  justify-content: center;
  align-items: center;
}
#image_preview{
  width: 20rem;
  text-align: center;
}
.list_rail{
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.item_button{
  width: 3rem;
  height: 3rem;
  background: #ffffff;
  border-radius: 5px;
  border: solid #000000 1px;
}
.checked{
  background: #129603;
  color: #ffffff;
}
.controls{
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
}
</style>

